import React from 'react';
import { Modal, Col, Row, Collapse, Icon } from 'antd';
import moment from 'moment';
const Panel = Collapse.Panel;
const phases = ['Investigation', 'Preparation', 'Action', 'Reflection', 'Demonstration'];

class ProjectGraph extends React.Component {

  render() {
    let green = '#06B696'
    let currentPhase = 'orange'
    let notCommplete = 'grey'

    const { graph, current_phase, labelVisisble, modalView, status, changePhase, showingPhase } = this.props
    let phaseIndex = phases.indexOf(current_phase)
    if ( phaseIndex == -1) { phaseIndex = 5}

    return (
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 15, alignItems: 'center', padding: modalView ? 0 : '0px 20px', width: '100%' }}>
        {
          phases.map((data, index) => {
            let color
            if (status === 'completed' || status === 'complete') {
              color = green
            }
            else if (current_phase === data) {
              color = currentPhase
            }
            else {
              let is_complete = graph.filter((d) => d.phase === data).map((x) => x.is_complete)[0];
              if (is_complete) {
                color = green
              } else {
                color = notCommplete
              }
            }
            return (
              <React.Fragment>
                <div onClick={() => changePhase && modalView && phaseIndex >= index && changePhase(index)} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row', zIndex: 1, cursor: phaseIndex >= index && 'pointer' }}>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{
                        backgroundColor: color,
                        height: modalView
                          ? index == showingPhase ? 90 : 70
                          : 40,
                        width: modalView
                          ? index == showingPhase ? 90 : 70
                          : 40,
                        borderRadius: modalView
                          ? index == showingPhase  ? 45 : 35
                          : 20,
                        border: modalView ? '4px solid #0A4C62' : '4px solid #000000',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}>
                        <div>
                          <p style={{ fontSize: 18, color: 'white', marginBottom: 0 }}>{index + 1}</p>
                        </div>
                      </div>

                    </div>
                    <p style={{ fontSize: 15, color: '#006588', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px', fontFamily: 'Muli', marginBottom: 0, textAlign: 'center', fontweight: 'bold', display: labelVisisble ? 'none' : 'inherit', position: 'relative', top: modalView && index !== 0 ? 10 : 0 }}>{data}</p>
                  </div>
                </div>
              </React.Fragment>
            )
          })
        }

      </div>
    );
  }
}

class Investigation extends React.Component {

  render() {

    const { currentPhase } = this.props
    return (
      <div>
        <div style={styles.cardLabel}>
          Why? Identify and State Need
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.identifyAndNeed}
        </div>

        <div style={styles.cardLabel}>
          How do you know that this need really exists?
        </div>
        <div style={styles.valueLabel}>
          <Row style={{ margin: '0 -10px' }}>
            {currentPhase.need &&
              currentPhase.need.map((item) =>
                <Col xs={4} style={{ padding: 5 }}>
                  <div style={styles.multipaleSelects}>{item}</div>
                </Col>
              )}
          </Row>
        </div>

        <div style={styles.cardLabel}>
          Research evidence
        </div>
        <div>
          {currentPhase.evidence && currentPhase.evidence.map(file => (
            <div style={{ display: 'inline-flex', alignItems: 'baseline', width: '100%' }}>
              <Icon type="paper-clip" style={{ marginRight: 15, fontSize: 18 }} />
              <a href={file.url} target="_blank"><p style={Object.assign({ marginBottom: 10 }, styles.valueLabel)}>{file.name}</p></a>
            </div>
          ))}
        </div>


        <div style={styles.cardLabel}>
          What? (Title of Project)
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.title}
        </div>

        <div style={styles.cardLabel}>
          Learner profile attribute
        </div>
        <div style={styles.valueLabel}>
          <Row style={{ margin: '0 -10px' }}>
            {currentPhase.learnerProfileAttribute &&
              currentPhase.learnerProfileAttribute.map((item) =>
                <Col xs={4} style={{ padding: 5 }}>
                  <div style={styles.multipaleSelects}>{item}</div>
                </Col>
              )}
          </Row>

        </div>
        <div style={styles.cardLabel}>
          Relevant Service Learning Outcomes
       </div>
        <div style={styles.valueLabel}>
          <Row style={{ margin: '0 -10px' }}>
            {currentPhase.relevantServiceLearningOutcomes &&
              currentPhase.relevantServiceLearningOutcomes.map(item =>
                <Col span={24} style={{ padding: 5 }}>
                  <div style={styles.multipaleSelectsWide}>{item}</div>
                </Col>
              )}
          </Row>
        </div>
        <div style={styles.cardLabel}>
          Type of Project
      </div>
        <div style={styles.valueLabel}>
          {currentPhase.projectType}
        </div>

        <div style={styles.cardLabel}>
          Desired Impact
      </div>
        <div style={styles.valueLabel}>
          {currentPhase.desiredImpact}
        </div>
        <div style={styles.cardLabel}>
          Notes
      </div>
        <div style={styles.valueLabel}>
          {currentPhase.notes}
        </div>


      </div>

      )

  }
}


class Preparation extends React.Component {


  render() {

    const { currentPhase } = this.props
    return (
      <div>

        <div style={styles.cardLabel}>
          Who (Which organization(s))?
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.who}
        </div>

        <div style={styles.cardLabel}>
          Where (Which location(s))?
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.where}
        </div>

        <div style={styles.cardLabel}>
          When (Which timeframe / frequency)?
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.when}
        </div>

        <div style={styles.cardLabel}>
          How (What resources will I need)?
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.how}
        </div>

        <div style={styles.cardLabel}>
          Expected Completion Date
        </div>
        <div style={styles.valueLabel}>
          {moment.unix(currentPhase.expectedCompletionDate).format('YYYY/MM/DD')}
        </div>

        <div style={styles.cardLabel}>
          Notes
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.notes}
        </div>

      </div>)

  }
}

class Action extends React.Component {

  render() {
    const { currentPhase } = this.props
    const actions = currentPhase.actionObject
    if (actions) {
      return (
        <div>
          {actions && Object.values(actions).map((item) => {
            console.log('item', item);
            return (<Collapse
              bordered={false}
              defaultActiveKey={['1']}
              expandIcon={({ isActive }) => <Icon type="caret-right" rotate={isActive ? 90 : 0} />}
            >
              <Panel header={item.title} key="1" style={styles.customPanelStyle}>
                <p>{item.notes}</p>
                <div style={{ display: 'inline-flex' }}>
                  <div>
                    <Icon type="paper-clip" style={{ marginRight: 15 }} />
                  </div>
                  <div>
                    {item.downloadURL && item.downloadURL.map(file => (
                      <a href={file.url} target="_blank"><p style={{ marginBottom: 10 }}>{file.name}</p></a>
                    ))}
                  </div>
                </div>
              </Panel>

            </Collapse>
            )
          })}
        </div>)
    } else {
      return (
        <div>
          <h1 style={styles.title}>Actions</h1>
          <div>There is not any action registered yet.</div>
        </div>)
    }

  }
}

class Demonstration extends React.Component {



  render() {

    const { currentPhase } = this.props
    return (
      <div>
        <div style={styles.cardLabel}>
          What did I learn?
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.what_learned}
        </div>
        <div style={styles.cardLabel}>
          How did I learn?
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.how_learned}
        </div>
        <div style={styles.cardLabel}>
          What did you advance/accomplish/contribute to? 
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.accomplishments}
        </div>
        <div style={styles.cardLabel}>
          Notes
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.notes}
        </div>

        <div style={styles.cardLabel}>
          Documents
        </div>
        <div>
          {currentPhase.documents && currentPhase.documents.map(file => (
            <div style={{ display: 'inline-flex', alignItems: 'baseline', width: '100%' }}>
              <Icon type="paper-clip" style={{ marginRight: 15, fontSize: 18 }} />
              <a href={file.url} target="_blank"><p style={Object.assign({ marginBottom: 10 }, styles.valueLabel)}>{file.name}</p></a>
            </div>
          ))}
        </div>
      </div>)

  }
}

class Reflection extends React.Component {

  render() {

    const { currentPhase, learningOutcomes, atl_category, feeling } = this.props
    return (
      <div>
        <div style={styles.cardLabel}>
          Learner profile attribute
        </div>
        <div style={styles.valueLabel}>
          <Row style={{ margin: '0 -10px' }}>
            {currentPhase.learnerProfileAttribute &&
              currentPhase.learnerProfileAttribute.map((item) =>
                <Col span={12} style={{ padding: 5 }}>
                  <div style={styles.multipaleSelects}>{item}</div>
                </Col>
              )}
          </Row>
        </div>

        <div style={styles.cardLabel}>
          Relevant Service Learning Outcomes
        </div>
        <div style={styles.valueLabel}>
          <Row style={{ margin: '0 -10px' }}>
            {currentPhase.learningOutcomes &&
              currentPhase.learningOutcomes.map((item) =>
                <Col span={24} style={{ padding: 5 }}>
                  <div style={styles.multipaleSelects}>{item}</div>
                </Col>
              )}
          </Row>
        </div>
        <div style={styles.cardLabel}>
          Skills
        </div>
        <div style={styles.valueLabel}>
          <Row tyle={{ margin: '0 -10px' }}>
            {currentPhase.ATLCategories &&
              currentPhase.ATLCategories.map((item) =>
                <Col span={12} style={{ padding: 5 }}>
                  <div style={styles.multipaleSelects}>{item}</div>
                </Col>
              )}
          </Row>
        </div>
        <div style={styles.cardLabel}>
          Actual Impact
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.actualImpact}
        </div>
        <div style={styles.cardLabel}>
          Compose you reflection
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.writeReflection}
        </div>

        <div style={styles.cardLabel}>
          Documents/reflection/presentation
        </div>
        <div>
          {(currentPhase && currentPhase.uploadEvidence) && currentPhase.uploadEvidence.map(file => (
            <div style={{ display: 'inline-flex', alignItems: 'baseline', width: '100%' }}>
              <Icon type="paper-clip" style={{ marginRight: 15, fontSize: 18 }} />
              <a href={file.url} target="_blank"><p style={Object.assign({ marginBottom: 10 }, styles.valueLabel)}>{file.name}</p></a>
            </div>
          ))}
        </div>

        <div style={styles.cardLabel}>
          Notes
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.notes}
        </div>

        <div style={styles.cardLabel}>
          Selected Emoticon
        </div>
        <div style={styles.valueLabel}>
          {Number.isNaN(Number(feeling)) ? feeling : emotions[feeling]}
        </div>

        <div style={styles.cardLabel}>
          Why did you choose this emoticon
        </div>
        <div style={styles.valueLabel}>
          {currentPhase.why_emoticon}
        </div>

      </div>)

  }
}


class IndividualProjectCard extends React.Component {

  state = {
    visible: false,
    project: this.props.project,
    showingPhase: null
  }

  showModal = () => {
    this.setState({
      visible: true
    });
  }
  hideModal = () => {
    this.setState({
      visible: false
    });
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.visible && prevState.visible !== this.state.visible && this.props.project) {
      if (this.props.project.current_phase !== 'complete' && this.props.project.current_phase !== 'completed') {
        let showingPhase = phases.indexOf(this.props.project.current_phase)
        if (showingPhase == -1) {
          showingPhase = 4
        }
        this.setState({showingPhase})
      } else {
        this.setState({
          showingPhase: 'Reflection'
        })
      }
    }
  }

  changePhase = index => {
    let phase;
    this.setState({showingPhase: index})
  }

  render() {
    const { t, project, studentName, myp, learningOutcomes, atl_category, status } = this.props

    let graph = []

    project && Object.entries(project).map(item => item[1].is_complete && graph.push({ 'phase': item[0], 'is_complete': item[1].is_complete }))

    return (
      <div>
        < Modal
          visible={this.state.visible}
          onOk={this.hideModal}
          width="796px"
          onCancel={this.hideModal}
          footer={null}
          className="serviceTracker"
        >
          <div style={styles.graph}>
            <div style={{ padding: '0px 20px', width: '98%' }}>
              <div style={{ width: '100%', height: 6, backgroundColor: '#0A4C62', position: 'relative', top: 62, zIndex: 0 }} />
            </div>
            <ProjectGraph changePhase={this.changePhase} showingPhase={this.state.showingPhase} modalView={true} graph={graph} hrWidth={70} labelVisisble={false} status={status} current_phase={project.current_phase} />
          </div>
          {this.state.showingPhase == 0 &&
            <Investigation currentPhase={project['Investigation']} projectTitle={project.projectTitle} />
          }
          {this.state.showingPhase == 1 &&
            <Preparation currentPhase={project['Preparation']} />}
          {this.state.showingPhase == 2 &&
            <Action currentPhase={project['Action']} />}
          {this.state.showingPhase == 3 &&
            <Reflection feeling={project.feeling} learningOutcomes={learningOutcomes} atl_category={atl_category} currentPhase={project['Reflection']} />
          }
          {this.state.showingPhase == 4 &&
            <Demonstration currentPhase={project['Demonstration']} />
            }

        </Modal >

        <Col span={8} style={{ padding: 10 }}>
          <div>
            <div style={styles.projectCard} onClick={this.showModal}>
              <div style={styles.label}>
                Student Name
               </div>
              <div style={styles.value}>
                {studentName}
              </div>
              <div style={styles.label}>
                MYP
               </div>
              <div style={styles.value}>
                {myp}
              </div>
              <div style={styles.label}>
                Project Name
              </div>
              <div style={styles.value}>
                {project.projectTitle}
              </div>
              <div style={styles.graph}>
                <div style={{ padding: '0px 20px', width: '100%' }}>
                  <div style={{ width: '100%', height: 2, backgroundColor: 'black', position: 'relative', top: 36, zIndex: 0 }} />
                </div>
                <ProjectGraph graph={graph} labelVisisble={true} status={status} current_phase={project.current_phase} showingPhase={this.state.showingPhase} />
              </div>
              <div style={styles.currentPhase}>
                {project.status === 'completed' ? 'completed' : project.current_phase}
              </div>

            </div>

          </div>
        </Col>
      </div>
    )
  }
}

export default IndividualProjectCard;

const styles = {

  projectCard: {
    height: '383px',
    borderRadius: '10px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 0 2px 0 rgba(0,0,0,0.3)'
  },

  cardLabel: {
    color: '#4A4A4A',
    fontSize: '20px',
    fontWeight: 'bold',
    marginTop: 30
  },
  valueLabel: {
    color: '#4A4A4A',
    fontSize: '18px',
    fontWeight: 100
  },
  multipaleSelects: {
    borderRadius: '10px',
    backgroundColor: '#4990E2',
    fontColor: 'White',
    textAlign: 'center',
    color: '#FFFFFF',
    minHeight: '40px',
    fontSize: '14px',
    paddingTop: 9
  },
  multipaleSelectsWide: {
    borderRadius: '10px',
    backgroundColor: '#4990E2',
    fontColor: 'White',
    textAlign: 'left',
    color: '#FFFFFF',
    minHeight: '40px',
    fontSize: '14px',
    paddingTop: 9,
    paddingLeft: 10
  },
  label: {
    color: '#4A4A4A',
    fontSize: '16px',
    fontWeight: '800',
    fontFamily: 'Muli',
    paddingTop: 30,
    paddingLeft: 30,
    display: 'flex',
    fontWeight: 800,
    alignItems: 'left',
    justifyContent: 'left',
    flexDirection: 'column'
  },

  currentPhase: {
    color: '#006588',
    fontFamily: 'Muli',
    fontSize: '12px',
    fontWeight: '800',
    paddingTop: 10,
    marginTop: 30,
    textAlign: 'center',
    textTransform: 'uppercase'
  },

  customPanelStyle: {
    background: '#f7f7f7',
    borderRadius: 4,
    marginTop: 20,
    border: 0,
    overflow: 'hidden'
  },


  value: {
    width: '310px',
    fontFamily: 'Muli',
    fontSize: '14px',
    paddingLeft: 30,
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'left',
    flexDirection: 'column'
  },
  graph: {
    fontFamily: 'Muli',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 10,
    flexDirection: 'column'
  },
  title: {
    fontFamily: 'Muli',
    fontSize: 26,
    fontWeight: 'bold'
  }
}


const emotions = [
  'Love',
  'Fascination',
  'Excitement',
  'Joy',
  'Boredom',
  'Worry',
  'Sad',
  'Anger'
];


// WEBPACK FOOTER //
// ./src/components/IndividualProjectCard/index.jsx